import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`To make sure you understand which user is performing actions within your app, you can identify users at any point. From the moment you make this call, all events will be identified with that distinct id.`}</p>
    <p>{`The ID can by anything, but is usually the unique ID that you identify users by in the database.
Normally, you would put this below `}<inlineCode parentName="p">{`posthog.init`}</inlineCode>{` if you have the information there.`}</p>
    <p>{`If a user was previously anonymous (because they hadn't signed up or logged in yet), we'll automatically alias their anonymous ID with their new unique ID. That means all their events from before and after they signed up will be shown under the same user.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`posthog.identify(
    '[user unique id]', // distinct_id, required
    { userProperty: 'value1' }, // $set, optional
    { anotherUserProperty: 'value2' } // $set_once, optional
);
`}</code></pre>
    <p>{`You can also pass two more arguments to `}<inlineCode parentName="p">{`posthog.identify`}</inlineCode>{`. Both take objects consisting of as many properties as you want to be set on that user's profile. The difference is that the second argument will use the `}<inlineCode parentName="p">{`$set`}</inlineCode>{` mechanism, whereas the third argument will use `}<inlineCode parentName="p">{`$set_once`}</inlineCode>{`. `}</p>
    <p>{`You can read more about the difference between this `}<a parentName="p" {...{
        "href": "/docs/integrate/client/js#setting-user-properties-via-an-event"
      }}>{`in the setting properties section`}</a>{`.`}</p>
    <blockquote className="warning-note">
    Warning! You can't call identify straight after an `.init` (as `.init` sends a pageview event, probably with the user's
    anonymous ID).
    </blockquote>
    <p>{`To address the issue described above, you can call `}<inlineCode parentName="p">{`.init`}</inlineCode>{` passing a `}<inlineCode parentName="p">{`loaded`}</inlineCode>{` callback function, inside which you can then call identify, like so:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`posthog.init('[your api key]', {
    api_host: 'https://posthog.[your-domain].com',
    loaded: function(posthog) { posthog.identify('[user unique id]'); }
});
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      